/* Fastlane Club Co. — reveal motion.
   Fail-safe by construction: content is visible unless THIS script tags it
   (.fcc-reveal) an instant before observing it, and a watchdog reveals
   everything after 4s no matter what the observer does. Reduced motion or
   no IntersectionObserver: nothing happens at all. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var SELECTOR = [
    '.hero__content-wrapper > *',
    '.product-grid > *',
    '.fcc-journal__header',
    '.fcc-journal__card',
    '.fcc-row-head',
    '.fcc-blog__masthead',
    '.fcc-blog__lead',
    '.fcc-blog__card',
    '.fcc-film__item',
    '.fcc-soundtrack__feature',
    '.fcc-soundtrack__row',
    '.fcc-wallpaper__cell',
    '.fcc-contact__row'
  ].join(',');

  try {
    var targets = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
    if (!targets.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fcc-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    targets.forEach(function (el) {
      var idx = Array.prototype.indexOf.call(el.parentElement.children, el);
      el.style.setProperty('--fcc-reveal-delay', Math.min(idx, 5) * 60 + 'ms');
      el.classList.add('fcc-reveal');
      io.observe(el);
    });

    setTimeout(function () {
      targets.forEach(function (el) { el.classList.add('fcc-in'); });
    }, 4000);
  } catch (e) {
    document.querySelectorAll('.fcc-reveal').forEach(function (el) {
      el.classList.add('fcc-in');
    });
  }
})();
